const CartUpsellRebind = () => {
    document.addEventListener('click', (e) => {
    const btn = e.target.closest('.upsell-form button[name="upsell-add"]');
    console.log(btn);
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const form = btn.closest('.upsell-form');
    const addButton = form.querySelector('[class^="upsell-add-button-"]') || btn;
    const textEl = addButton.querySelector('[class^="upsell-button-text-"]');
    const originalText = textEl ? textEl.textContent : addButton.textContent;

    // loading UI
    addButton.innerHTML = '<span class="button-spinner"></span>';
    addButton.classList.add('is-loading');
    addButton.disabled = true;

    const variantId = form.querySelector('input[name="id"]')?.value;
    if (!variantId) {
        addButton.innerHTML = `<span class="${textEl?.className || ''}">${originalText}</span>`;
        addButton.classList.remove('is-loading');
        addButton.disabled = false;
        return;
    }

    fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(r => r.ok ? r.json() : r.json().then(err => { throw new Error(err.description || r.statusText); }))
    .then(() => {
        const successText = "Added";
        addButton.innerHTML = `<span class="${textEl?.className || ''}">${successText ?? originalText}</span>`;
        addButton.classList.remove('is-loading');
        addButton.classList.add('upsell-add-success');

        setTimeout(() => {
        addButton.innerHTML = `<span class="${textEl?.className || ''}">${originalText}</span>`;
        addButton.classList.remove('upsell-add-success');
        addButton.disabled = false;
        }, 1500);

        // rafraîchir compte & drawer
        if (typeof window.updateCartCount === 'function') window.updateCartCount();
        if (typeof window.refreshCart === 'function') window.refreshCart();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:update'));
        if (window.THEME?.updateCartCount) window.THEME.updateCartCount();
        else if (typeof window.refreshMiniCart === 'function') window.refreshMiniCart();

        return fetch(`${window.routes.cart_url}?view=drawer`)
        .then(res => res.text())
        .then(html => {
            const doc = parser.parseFromString(html, 'text/html');
            const newCartDrawer = doc.querySelector('#CartDrawer');
            const container = document.querySelector('cart-drawer');
            if (container && newCartDrawer && typeof updateCartDrawer === 'function') {
            updateCartDrawer(container, newCartDrawer);
            }
        });
    })
    .catch(err => {
        console.error('upsell add error', err);
        addButton.innerHTML = `<span class="${textEl?.className || ''}">${originalText}</span>`;
        addButton.classList.remove('is-loading');
        addButton.classList.add('upsell-add-error');
        setTimeout(() => {
        addButton.classList.remove('upsell-add-error');
        addButton.disabled = false;
        }, 1500);
    });
    });
}

customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        super();
        this.originalButtonText = "";
        this.persistentTextActive = false;
      }

      connectedCallback() {
        setTimeout(() => {
          this.form = this.querySelector("form");
          if (!this.form) return;

          const variantInput = this.variantIdInput;
          if (variantInput) variantInput.disabled = false;

          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

          this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");

          this.submitButton = this.querySelector('[type="submit"]');
          if (!this.submitButton) return;

          this.submitButtonText = this.submitButton.querySelector(".button-text");

          if (this.submitButtonText) {
            this.originalButtonText = this.submitButtonText.textContent;
            this.submitButton.dataset.originalText = this.originalButtonText;
          }

          if (this.submitButton.dataset.textOverride === "true" && this.submitButtonText) {
            // text override active
          } else if (
            this.submitButton.classList.contains("has-persistent-text") &&
            this.submitButtonText
          ) {
            this.persistentTextActive = true;
            const persistentText = this.submitButton.dataset.persistentText;

            if (persistentText) {
              this.submitButtonText.textContent = persistentText;
              localStorage.setItem("addToCartButtonText", persistentText);
            } else {
              const savedText = localStorage.getItem("addToCartButtonText");
              if (savedText) {
                this.submitButtonText.textContent = savedText;
                this.submitButton.dataset.persistentText = savedText;
              }
            }
          }

          if (
            (this.persistentTextActive ||
              this.submitButton.dataset.textOverride === "true") &&
            this.submitButtonText
          ) {
            this.setupButtonTextObserver();
          }

          if (document.querySelector("cart-drawer")) {
            this.submitButton.setAttribute("aria-haspopup", "dialog");
          }

          this.hideErrors = this.dataset.hideErrors === "true";

          document.addEventListener(
            "variant:change",
            this.handleVariantChange.bind(this)
          );
        }, 100);
      }

      setupButtonTextObserver() {
        if (!this.submitButtonText) return;

        const observerConfig = { characterData: true, childList: true, subtree: true };

        if (this.persistentTextActive) {
          const persistentText =
            this.submitButton.dataset.persistentText ||
            localStorage.getItem("addToCartButtonText");

          if (!persistentText) return;

          this.buttonTextObserver = new MutationObserver(() => {
            if (this.submitButtonText.textContent !== persistentText) {
              this.submitButtonText.textContent = persistentText;
            }
          });

          this.buttonTextObserver.observe(this.submitButtonText, observerConfig);
        }
      }

      handleVariantChange() {
        if (!this.submitButtonText) return;

        setTimeout(() => {
          if (this.persistentTextActive) {
            const persistentText =
              this.submitButton.dataset.persistentText ||
              localStorage.getItem("addToCartButtonText");

            if (persistentText) {
              this.submitButtonText.textContent = persistentText;
            }
          }
        }, 50);
      }

      onSubmitHandler(event) {
        event.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((res) => res.json())
          .then((data) => {
            if (data.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: data.errors || data.description,
                message: data.message,
              });

              this.handleErrorMessage(data.description);

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;

              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const marker = CartPerformance.createStartingMarker("add:wait-for-subscribers");

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: data,
              }).then(() => {
                CartPerformance.measureFromMarker("add:wait-for-subscribers", marker);
              });
            }

            this.error = false;

            const modal = this.closest("quick-add-modal");
            if (modal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(data);
                    });
                  });
                },
                { once: true }
              );
              modal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(data);
              });
            }
          })
          .catch((err) => console.error(err))
          .finally(() => {
            this.submitButton.classList.remove("loading");

            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }

            if (!this.error) {
              this.submitButton.removeAttribute("aria-disabled");
            }

            this.querySelector(".loading__spinner").classList.add("hidden");

            if (!this.error && this.submitButton.dataset.textOverride !== "true") {
              if (this.persistentTextActive) {
                const persistentText =
                  this.submitButton.dataset.persistentText ||
                  localStorage.getItem("addToCartButtonText");

                if (persistentText && this.submitButtonText) {
                  this.submitButtonText.textContent = persistentText;
                }
              }
            }
            
            CartUpsellRebind();
            CartPerformance.measureFromEvent("add:user-action", event);
          });
      }

      handleErrorMessage(message = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !message);
        if (message) this.errorMessage.textContent = message;
      }

      toggleSubmitButton(disable = true, overrideText) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (overrideText) this.submitButtonText.textContent = overrideText;
          return;
        }

        this.submitButton.removeAttribute("disabled");

        if (this.submitButton.dataset.textOverride === "true") return;

        if (this.persistentTextActive) {
          const persistentText =
            this.submitButton.dataset.persistentText ||
            localStorage.getItem("addToCartButtonText");

          if (persistentText) {
            this.submitButtonText.textContent = persistentText;
            return;
          }
        }

        this.submitButtonText.textContent =
          this.originalButtonText ||
          this.submitButton.dataset.originalText ||
          window.variantStrings.addToCart;
      }

      disconnectedCallback() {
        if (this.buttonTextObserver) this.buttonTextObserver.disconnect();
        document.removeEventListener("variant:change", this.handleVariantChange);
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
